export const changeMonitoringLevel1Reducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_MonitoringLevel1":
      return action.payload.MonitoringLevel1;
    default:
      return state;
  }
};
